var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"userinfo"},[_c('svg-icon',{attrs:{"icon-class":"user"}}),_c('span',[_vm._v(_vm._s(_vm.name)+" - "+_vm._s(_vm.empresa.empr_descripcion)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }